import misRutas from 'vue-routes-generator'
import SubirXframeComponent from './App'

export default {
	install: Vue => {
		misRutas.route('/main').child('subir-xframe', {
			name: 'Subir XFrame',
			component: SubirXframeComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/subir-xframe/vue/index.js